"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterSizeOptionModeState = void 0;
var SfilterSizeOption_init_1 = require("@/pages/common/states/sfilter/sections/size/SfilterSizeOption.init");
var SfilterSizeCustomOption_init_1 = require("@/pages/common/states/sfilter/sections/size/SfilterSizeCustomOption.init");
exports.defaultSfilterSizeOptionModeState = {
    customOpened: false,
    selected: -1,
    options: SfilterSizeOption_init_1.defaultSfilterSizeOptions,
    customOptions: SfilterSizeCustomOption_init_1.defaultSfilterSizeCustomOption,
};
